module.exports = __webpack_public_path__ + "img/roll-468.67e410bf.png";